import { FC, HTMLAttributes } from "react";
import { useStyles } from "./ShopAvatar.style";
import { Skeleton } from "@onmo/ui";

export const ShopAvatarLoading: FC<HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const { ...otherProps } = props;
  const classes = useStyles();

  return (
    <div className={classes.root} {...otherProps}>
      <Skeleton variant="circle" width={80} height={80} />
      <Skeleton variant="text" width={80} height={30} borderRadius={100} />
    </div>
  );
};

export default ShopAvatarLoading;
